export interface ListenToStreamResults {
    sampleRate: number;
}

export class MicrophoneStream {
    private audioContext: AudioContext;
    private source: MediaStreamAudioSourceNode;
    private scriptNode: ScriptProcessorNode;

    listenToStream(stream: MediaStream, callback: (_: Float32Array) => void): ListenToStreamResults {
        this.audioContext = new AudioContext();
        this.source = this.audioContext.createMediaStreamSource(stream);
        this.scriptNode = this.audioContext.createScriptProcessor(4096, 1, 1);

        this.source.connect(this.scriptNode);
        this.scriptNode.connect(this.audioContext.destination);
        this.scriptNode.onaudioprocess = function (event: AudioProcessingEvent) {
            const audioData = event.inputBuffer.getChannelData(0);
            callback(audioData);
        };

        return {
            sampleRate: this.audioContext.sampleRate,
        };
    }

    stopListening() {
        this.scriptNode.onaudioprocess = null; // Remove the event handler
        this.scriptNode.disconnect(); // Disconnect the scriptNode
        this.source.disconnect(); // Disconnect the source
        this.audioContext.close(); // Close the audio context
    }
}
